module.exports = __webpack_public_path__ + "img/arrowLeft.9e460ce1.svg";